import React from 'react';
import Footer from '../layouts/global/Footer';
import NavBar from '../layouts/global/NavBar';
import Hero from '../layouts/landing-page/Hero';
import Offers from '../layouts/landing-page/Offers';

export default function Home() {
  return (
    <div className={'bg-white'}>
      <NavBar />
      <div className={'pt-20 lg:pt-5'}>
        <Hero />
        <Offers />
        <Footer />
      </div>
    </div>
  );
}
